<template>
  <div id="comp-modal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header" v-if="titleShow">
              <slot name="header">
                default header
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                default body
              </slot>
            </div>

            <div class="modal-footer">
              <div class="btn-alone"
                   v-if="!buttonTwo"
                   @click="$emit('confirm')"
              >{{ $t('common.confirm') }}</div>

              <div class="btn-cancel" v-if="buttonTwo" @click="$emit('cancel')">
                {{ $t('common.cancel') }}
              </div>
              <div class="btn-confirm" v-if="buttonTwo" @click="$emit('confirm')">
                {{ $t('common.confirm') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'comp-modal',
  props: {
    buttonTwo: Boolean,
    titleShow: Boolean,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" src="../scss/comp-modal.scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CompModal.vue